import React from 'react';
import ReactDOM from 'react-dom';

import './Dropdown.scss';
import './Animations.scss';

const DROPDOWN_ARROW_SRC = '../images/appointment/icon-expanded.svg';

export default class Dropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            placeholder: props.placeholder,
            isUp: false
        };

        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.hide = this.hide.bind(this);
    }

    componentDidMount() {
        const UP_THRESHOLD_PX = 750;

        let position = ReactDOM.findDOMNode(this).getBoundingClientRect();

        if (position.bottom > UP_THRESHOLD_PX) {
            this.setState({
                isUp: false
            });
        }
    }

    render() {
        let expandedClass = this.state.isExpanded ? 'expanded' : '';
        let invalidClass = this.props.isInvalid ? 'invalid' : '';
        let disabledClass = this.props.disabled ? 'disabled' : '';
        let isUpClass = this.state.isUp ? 'up' : '';

        return (
            <div className={`d-dropdown ${expandedClass} ${this.props.styleClass} ${invalidClass} ${disabledClass}`}>
                <div className="d-label" onClick={this.toggleVisibility}>
                    {this.selectedItem ? this.selectedItem.label : this.state.placeholder}
                    <span className="d-trigger">
                        <img className="d-arrow" src={DROPDOWN_ARROW_SRC}></img>
                    </span>
                </div>

                {this.state.isExpanded &&
                    <ul className="d-select-list">
                    
                        {this.props.items.map((current) => {
                        return (
                            <li
                                className="d-select-item"
                                key={current.value}
                                onClick={(e) => this.select(e, current.value)}>
                                {current.label}
                            </li>);
                        })}
                    </ul>}
            </div>
        );
    }

    toggleVisibility() {
        this.state.isExpanded ? this.hide() : this.show();
    }

    show() {
        if (this.props.disabled) return;

        this.setState({
            isExpanded: true
        });
        document.addEventListener('click', this.hide);
    }

    hide() {
        this.setState({
            isExpanded: false
        });
        document.removeEventListener('click', this.hide);
    }

    get selectedItem() {
        if (!this.props.selectedValue) return null;

        return this.props.items.filter((current) => {
            return current.value === this.props.selectedValue;
        })[0];
    }

    select(e, value) {
        e.stopPropagation();

        this.toggleVisibility();

        let eventArgs = {
            target: {
                name: this.props.name,
                value: value
            }
        };

        this.props.onSelect(eventArgs);
    }
}


// WEBPACK FOOTER //
// ./Src/Appointment/AppointmentScheduler/Dropdown/Dropdown.jsx